module.exports = __webpack_public_path__ + "static/media/lashpic7.65fd8782.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Pretty_Lashed/gp/lashpic7.JPG
// module id = 455
// module chunks = 0